import React, { useEffect, useState } from 'react';
import LPRDialog from '../../LPRDialog';
import MemoDialog from '../../MemoDialog';
import OrderOfPaymentDialog from '../../LeaseDocuments/OrderOfPayment';
import PDFWindow from 'src/components/common/PDFWindow';
import IContract from 'src/models/contract_types/IContract';
import ContractAddendumClause from './ContractAddendumClause';
import LeaseClauseType from 'src/models/LeaseClauseType';
import LocationModel from 'src/models/leasing/LocationModel';
import Lease from 'src/models/leasehold/Lease';
import Samsung1 from '../../LeaseDocuments/SurfaceWaiverLeaseDocs/Samsung1';
import Samsung3 from '../../LeaseDocuments/SurfaceWaiverLeaseDocs/Samsung3';
import PalladiumEnergy from '../../LeaseDocuments/SurfaceWaiverLeaseDocs/PalladiumEnergy';
import { UseFormMethods } from 'react-hook-form';
import DemoLease from '../../LeaseDocuments/DemoLease';
import AethonMemo from '../../MemoTemplates/AethonMemo';
import AethonOOP from '../../OOPTemplates/AethonOOP';
import AethonLease from '../../OGTemplates/AethonTemplate';
import BrineLease from 'src/models/contract_types/BrineLease';
import IndexReferenceType from 'src/models/IndexReferenceType';
import SaltwerxBrineLeaseTemplate from '../../BrineTemplates/SaltwerxBrineLeaseTemplate';
import BrineMemo from '../../MemoTemplates/BrineMemo';
import SaltwerxOOP from '../../OOPTemplates/SaltwerxOOP';
import SaltwerxBrineLeaseProps from 'src/models/leaseTemplateProps/SaltwerxBrineLeaseProps';
import FormonteraLease from '../../OGTemplates/FormonteraTemplate';
import FormonteraMemo from '../../MemoTemplates/FormonteraMemo';

interface IContractPdfGeneration extends Partial<Pick<UseFormMethods, 'getValues'>> {
    contractData: IContract;
    contractClauses: ContractAddendumClause[];
    leaseClauseTypes: LeaseClauseType[];
    measurementTypes?: IndexReferenceType[];
    location: LocationModel;
    renderTypeId?: number;
    netAcres?: number;

    hideDialog: () => void;
}

const ContractPdfGeneration = (props: IContractPdfGeneration) => {
    const [showDemo, setShowDemo] = useState<boolean>(false);

    // TODO: Remove this when the render Type Id is better defined.
    useEffect(() => {
        setShowDemo(!props.renderTypeId || props.renderTypeId < 2 || props.renderTypeId > 5);
    }, [props]);

    return (
        <div>
            {/* Conditionally Rendering Memo */}
            {showDemo && (
                <>
                    <LPRDialog leaseData={props.getValues()} />
                    <MemoDialog leaseData={props.contractData as Lease} leaseClauses={props.contractClauses} leaseClauseTypes={props.leaseClauseTypes} />
                    <OrderOfPaymentDialog leaseClauses={props.contractClauses} leaseClauseTypes={props.leaseClauseTypes} location={props.location} />
                    <PDFWindow>
                        <DemoLease contractData={props.contractData} leaseClauses={props.contractClauses} leaseClauseTypes={props.leaseClauseTypes} />
                    </PDFWindow>
                </>
            )}
            {props.renderTypeId === 2 && (
                <>
                    <AethonMemo leaseData={props.contractData as Lease} leaseClauses={props.contractClauses} leaseClauseTypes={props.leaseClauseTypes} location={props.location} />
                    <FormonteraMemo leaseData={props.contractData as Lease} leaseClauses={props.contractClauses} leaseClauseTypes={props.leaseClauseTypes} location={props.location} />
                    <AethonOOP leaseData={props.contractData as Lease} leaseClauses={props.contractClauses} leaseClauseTypes={props.leaseClauseTypes} location={props.location} />
                    <PDFWindow>
                        <AethonLease contractData={props.contractData as Lease} leaseClauses={props.contractClauses} leaseClauseTypes={props.leaseClauseTypes} location={props.location} />
                    </PDFWindow>\
                    <PDFWindow>
                        <FormonteraLease contractData={props.contractData as Lease} leaseClauses={props.contractClauses} leaseClauseTypes={props.leaseClauseTypes} location={props.location} />
                    </PDFWindow>
                </>
            )}

            {props.renderTypeId === 3 && (
                <>
                    <PDFWindow>
                        <Samsung1
                            contractData={props.contractData}
                            contractAddendumClauses={props.contractClauses}
                            contractClauseTypes={props.leaseClauseTypes}
                            locationData={props.location}
                        />
                    </PDFWindow>
                    <SaltwerxOOP
                        leaseProps={SaltwerxBrineLeaseProps.from(
                            props.contractData as BrineLease, 
                            props.measurementTypes, 
                            props.leaseClauseTypes, 
                            props.contractClauses, 
                            props.location, 
                            props.netAcres
                        )}
                    />

                    <PDFWindow>
                        <SaltwerxBrineLeaseTemplate
                            leaseProps={SaltwerxBrineLeaseProps.from(props.contractData as BrineLease, props.measurementTypes, props.leaseClauseTypes, props.contractClauses)}
                        />
                    </PDFWindow>

                    <BrineMemo 
                        leaseProps={SaltwerxBrineLeaseProps.from(props.contractData as BrineLease, props.measurementTypes, props.leaseClauseTypes, props.contractClauses, props.location)}
                    />
                </>
            )}
            {props.renderTypeId === 4 && (
                <PDFWindow>
                    <Samsung3
                        contractData={props.contractData}
                        contractAddendumClauses={props.contractClauses}
                        contractClauseTypes={props.leaseClauseTypes}
                        locationData={props.location}
                    />
                </PDFWindow>
            )}
            {props.renderTypeId === 5 && (
                <PDFWindow>
                    <PalladiumEnergy
                        contractData={props.contractData}
                        contractAddendumClauses={props.contractClauses}
                        contractClauseTypes={props.leaseClauseTypes}
                        locationData={props.location}
                    />
                </PDFWindow>
            )}
        </div>
    );
};

export default ContractPdfGeneration;


// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractPdfGeneration.tsx